"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.sync.model.button': 'Synchronizuj Model',
    'chat.sync.model.tooltip': 'Synchronizuj z modelem konwersacji',
};
